<div *ngIf="!canAccessCards()">
    <mcp-no-access></mcp-no-access>
</div>
<div *ngIf="canAccessCards()"fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="30px" class="ml-30 mt-30">
    <ng-container *ngFor="let card of menuOptions">
        <med-card *ngIf="card.visible" class="landing-card mb-30" fxLayout="column" fxLayoutAlign="center stretch"
            fxLayoutGap="10px" [routerLink]="card.url">
            <div fxFlex="65">
                <img fxFlex [src]="card.imageSrcPath">
            </div>
            <div fxFlex="15">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <span class="bold">{{card.landingPageTitle | translate}}</span>
                    <span class="bold" *ngIf="card.landingPageSubtitle">{{card.landingPageSubtitle | translate}}</span>
                    <span *ngIf="card.description">{{card.description | translate }}</span>
                </div>
            </div>
            <div fxFlex="20">
                <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                    <a [routerLink]="card.url" class="bold">{{'enter' | translate }}</a>
                </div>
            </div>
        </med-card>
    </ng-container>
</div> 